import type { SlaStanding, SlaView } from '../lib/types';
import { SLA_STANDING_LABELS, formatClock } from '../lib/types';
import { formatDateTime } from '../lib/dates';

const STANDING_CLASS: Record<SlaStanding, string> = {
  breached: 'badge badge-accent',
  at_risk: 'badge badge-warn',
  on_track: 'badge badge-ok',
  met: 'badge badge-ok',
};

/**
 * The clock, small enough for a card or a table cell. Shows whichever target is still running
 * — the response until it is answered, then the resolution — because that is the one anyone
 * can still do something about.
 */
export function SlaBadge({ sla, compact = false }: { sla: SlaView; compact?: boolean }) {
  const live = sla.response && sla.response.remainingMinutes !== null ? sla.response : sla.resolution;
  const label = sla.response && sla.response.remainingMinutes !== null ? 'reply' : 'fix';

  if (sla.paused) {
    return (
      <span className="badge" title={`Clock stopped${sla.pausedSince ? ` since ${formatDateTime(sla.pausedSince)}` : ''} — waiting on the customer`}>
        ⏸ paused
      </span>
    );
  }

  if (!live || live.remainingMinutes === null) {
    return <span className={STANDING_CLASS[sla.standing]}>{SLA_STANDING_LABELS[sla.standing]}</span>;
  }

  const title = [
    sla.response && `Reply by ${formatDateTime(sla.response.due)}${sla.response.met ? ' — answered' : ''}`,
    sla.resolution && `Fix by ${formatDateTime(sla.resolution.due)}`,
    sla.pausedMinutes > 0 && `${sla.pausedMinutes} min of waiting excluded`,
  ]
    .filter(Boolean)
    .join('\n');

  return (
    <span className={STANDING_CLASS[sla.standing]} title={title}>
      {compact ? '' : `${label} `}
      {formatClock(live.remainingMinutes)}
    </span>
  );
}
